import { Spinner as DesignSystemSpinner } from 'design-system';

type SpinnerProps = {
  size?: number | string;
  centered?: boolean;
};

// MUI's CircularProgress defaulted to 40px; keep that default so every
// existing caller (most of which render `<Loader />` with no size) matches.
const Spinner = ({ size = 40, centered = true }: SpinnerProps) => {
  const progress = <DesignSystemSpinner style={{ width: size, height: size }} />;

  if (!centered) return progress;

  return <div className='flex h-full w-full flex-1 items-center justify-center'>{progress}</div>;
};

export default Spinner;
export { Spinner };
